<template>
  <div class="icon-select" :class="{ active: active, hover: hover }" @click="handleClick">
    <div class="label" v-if="label">
      {{ label }}
    </div>
    <div class="box">
      <div :class="icon" v-if="icon"></div>
      <slot name="svgIcon"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconRadioBox',
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true,
    },
    hover: {
      type: Boolean,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click', this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mo-custom';
.icon-select {
  color: $mute-color;
  transition: all 200ms 0s ease;
  border-color: $border-color;
  cursor: pointer;

  &.active {
    color: $primary-color;
    border-color: $primary-color;
  }
  &.hover {
    &:hover {
      color: $primary-color;
      border-color: $primary-color;
    }
  }
  .label {
    font-size: 1.2em;
    font-weight: 500;
    text-align: center;
  }
  .box {
    font-size: 2.5em;
    line-height: 1em;
    text-align: center;
    padding: 0.3em;
    width: 100%;
    border: 2px solid;
    border-radius: 4px;
  }
}
</style>
